import script from "./VirtualizedEzOrderTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VirtualizedEzOrderTable.vue?vue&type=script&setup=true&lang=ts"

import "./VirtualizedEzOrderTable.vue?vue&type=style&index=0&id=c3b4818a&lang=scss&scoped=true"
import "./VirtualizedEzOrderTable.vue?vue&type=style&index=1&id=c3b4818a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3b4818a"]])

export default __exports__